import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import { useLocation } from "react-router-dom";
import authentificationService from '../../services/authentificationService';
import localStorageService from '../../services/localStorageService';
import axios from "axios";
import { api } from "../../services/apiHelpers";
import CustomAlert from '../shared/views/CustomAlert';
import { CircularProgress } from '@material-ui/core';

export const AdminLayout = (props) => {

    const location = useLocation();
    const [currrentPathName, setCurrrentPathName] = React.useState("");
    const [userPermissionsList, setUserPermissionsList] = React.useState([]);
    const [hasUserAcces, setHasUserAcces] = React.useState(true);
    const [isLoading, setIsLoading] = React.useState(true);
    

    const checkUserAccess = () => {
        setHasUserAcces(userPermissionsList?.some(p => p.name === "AllowAdminToManageUser" && p.isAllowed === true));
    }

    useEffect(() => {
        checkUserAccess();
    }, [userPermissionsList]);


    useEffect(() => {
        getPathName();

        var user = authentificationService.getUser();
        if (user !== undefined && user !== null) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${user.token}`;
            
        }

        let currentUser = localStorageService.getItem("malibaara_auth_user");
        if(currentUser && currentUser.id){
            axios.get(`${api}/Users/permissions/${currentUser.id}`).then(res => {
            setUserPermissionsList(res.data.permissions);
            setIsLoading(false);
        })
        }
        
    }, [])

    useEffect(() => {
        setCurrrentPathName(location.pathname);
    }, [location])

    let getPathName = () => {
        let pathName = window.location.pathname;
        setCurrrentPathName(pathName);
    }

    return (
        <>
            {(currrentPathName != "/admin/signin" && !currrentPathName.toLowerCase().includes("resetpassword")) ?
                (
                    <>
                        <Header candidateLayoutLoaded={false} />
                        <React.Fragment>
                            <section className="space-ptb bg-light " style={{ padding: "50px 0" }}>
                                <div className="container user-dashboard-info-box">                                      
                                    <div className="row">
                                        <div className="col-lg-3">
                                            <div className="bg-white p-4 shadow-sm">
                                                <div className="secondary-menu">
                                                    <ul className="list-unstyled mb-0">
                                                        <li><a className={(currrentPathName.includes("/admin/dashboard") || currrentPathName == "/admin") ? "active" : ""} href="/admin/dashboard" key={"dashboard"}>Dashboard</a></li>
                                                        <li><a className={(currrentPathName.includes("/admin/jobs") || currrentPathName.includes("/admin/job")) ? "active" : ""} href="/admin/jobs" key={"job"}>Offres d'emploi</a></li>
                                                        <li><a className={(currrentPathName.includes("/admin/tenders") || currrentPathName.includes("/admin/tender")) ? "active" : ""} href="/admin/tenders" key={"tenders"}>Appels d'offre</a></li>
                                                        <li><a className={(currrentPathName.includes("/admin/courses") || currrentPathName.includes("/admin/course")) ? "active" : ""} href="/admin/courses" key={"course"}>Formations</a></li>
                                                        <li><a className={currrentPathName.includes("/admin/applications") ? "active" : ""} href="/admin/applications/list" key={"applications"}>Postulations</a></li>
                                                        <li><a className={currrentPathName.includes("/admin/employers") ? "active" : ""} href="/admin/employers" key={"employers"}>Employeurs</a></li>
                                                        <li><a className={currrentPathName.includes("/admin/candidates") ? "active" : ""} href="/admin/candidates" key={"candidates"}>Candidats</a></li>
                                                        <li><a className={currrentPathName.includes("/admin/ads") ? "active" : ""} href="/admin/ads" key={"ads"}>Publicités</a></li>
                                                        <li><a className={(currrentPathName.includes("/admin/smsNotifications") || currrentPathName.includes("/admin/smsNotification/details")) ? "active" : ""} href="/admin/smsNotifications" key={"smsNotifications"}>SMS</a></li>
                                                        {userPermissionsList?.some(p => p.name === "AllowAdminToManageUser") && (
                                                            <li>
                                                                <a className={currrentPathName.includes("/admin/users") ? "active" : ""} href="admin/users" key={"users"}>Utilisateurs</a>
                                                            </li>
                                                        )}                                                        
                                                        <li><a className={currrentPathName.includes("/admin/operations") ? "active" : ""} href="/admin/operations" key={"operations"}>Opérations</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>                                        
                                        <div className="col-lg-9">  
                                        {isLoading ? 
                                            <div className="loading-container">
                                                <CircularProgress />
                                            </div>
                                            :
                                            (currrentPathName.includes("/admin/users") && !userPermissionsList?.some(p => p.name === "AllowAdminToManageUser")) ? (
                                                 <div className="row  pt-4 mt-lg-0">
                                                   <CustomAlert type="alert-warning" content={"Cette opération n'est pas disponible pour cet utilisateur. Veuillez contacter un administrateur de Malibaara"} />                                                         
                                                </div>
                                            ) : 
                                                props.children
                                            
                                        }
                                                                   
                                            {/* {}  */}
                                        </div>                                       
                                    </div>
                                </div>
                            </section>
                        </React.Fragment>
                        <Footer />
                    </>
                )
                :
                (
                    <>
                        {props.children}
                    </>
                )}

        </>
    );
}